<div class="standard-toolbar">
    <nav class="navbar navbar-light" [class.navbar-expand-xl]="!displayToggle" [class.navbar-expand-xxl]="displayToggle">
        <ng-content select="[icon]"></ng-content>
        <div class="right-side-container">
            <ng-content select="[rightSideContainer]"></ng-content>
        </div>
        <button class="navbar-toggler" type="button" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
            <i class="fas fa-ellipsis-h"></i>
        </button>
        <div class="navbar-collapse collapse" [ngClass]="{ show: isExpanded }">
            <ng-content select="[menuItems]"></ng-content>
        </div>
    </nav>
</div>
